import {
	OPERATOR_LOGIN_SUCCESS,
	OPERATOR_LOGIN_ERROR,
	OPERATOR_LOGIN_START,
	CLEAR_OPERATOR_PREVIOUS_REDUCER,
	OPERATOR_VERIFICATION_SUCCESS,
	OPERATOR_VERIFICATION_ERROR,
	OPERATOR_VERIFICATION_START,
} from "Constant";
import { request } from "utils/request";

import {
	getloginEncriptionstring,
	getloginDetail,
	verifyUserApi,
} from "Constant/apiConstant";
import { getCookie } from "BridgeFunction";
import {
	RENTAL_MODULE,
	RENTAL_OPERATOR,
	TOUR_MODULE,
	TOUR_OPERATOR,
} from "Constant/UsreConstant";
import { displayNotification } from "store/action";

const newLoginStart = () => {
	return { type: OPERATOR_LOGIN_START };
};

const newLoginSuccess = (payload) => {
	return { type: OPERATOR_LOGIN_SUCCESS, payload };
};

const newLoginError = (error) => {
	return { type: OPERATOR_LOGIN_ERROR, error };
};

const clearPreviousOeratorLoginReducer = () => {
	return { type: CLEAR_OPERATOR_PREVIOUS_REDUCER };
};

const newLoginEncriptionString =
	(payload, callback) => (dispatch, getState) => {
		dispatch(newLoginStart());
		var body = { string: payload };
		try {
			request("POST", getloginEncriptionstring, body, false)
				.then((res) => {
					dispatch(newLoginSuccess(res?.data));
					callback(res?.data);
				})
				.catch((err) => {
					dispatch(newLoginError(err));
				});
		} catch (error) {
			dispatch(newLoginError("Something went wrong"));
		}
	};

const checkLoginUser = (token, type, callback) => (dispatch, getState) => {
	dispatch(newLoginStart());
	const header = {
		"Content-Type": "application/json",
		Authentication: token,
	};
	try {
		request("POST", `${getloginDetail}?userType=${type}`, {}, false, header)
			.then((res) => {
				if (res?.code == "200") {
					if (type === TOUR_OPERATOR) {
						res.data.partner_module = TOUR_MODULE;
						res.data.user_role_module = TOUR_OPERATOR;
					} else {
						res.data.partner_module = RENTAL_MODULE;
						res.data.user_role_module = RENTAL_OPERATOR;
					}
					dispatch(newLoginSuccess(res));
					callback(res);
				} else {
					dispatch(newLoginError(res));
					callback(res);
				}
			})
			.catch((err) => {
				dispatch(newLoginError(err));
				callback(err);
				dispatch(
					displayNotification({
						open: true,
						message: err?.message
							? err?.message
							: "something went wrong",
						duration: 6000,
						severity: "error",
					})
				);
			});
	} catch (error) {
		dispatch(newLoginError("Something went wrong"));
		dispatch(
			displayNotification({
				open: true,
				message: error?.message
					? error?.message
					: "something went wrong",
				duration: 6000,
				severity: "error",
			})
		);
	}
};

const verifyUser = (callback) => (dispatch, getState) => {
	const headerOptions = {
		Authorization: getCookie(process.env.REACT_APP_OPERATOR_DEV_COOKIE),
	};
	try {
		request("GET", verifyUserApi, {}, false, headerOptions)
			.then((res) => {
				callback && callback(res);
			})
			.catch((err) => {
				callback && callback(err);
			});
	} catch (error) {
		callback && callback("Something went wrong");
	}
};

const updateProfilePic = (payload, callback) => (dispatch, getState) => {
	dispatch(newLoginSuccess(payload));
};
const clearLoginData = () => (dispatch, getState) => {
	dispatch(newLoginSuccess(null));
};

export {
	checkLoginUser,
	newLoginEncriptionString,
	verifyUser,
	updateProfilePic,
	clearLoginData,
	clearPreviousOeratorLoginReducer,
};
